import { getPermissionDisplayLabel, getParentPermissionForValue } from '../utils/permission-groups';
import {
    areAllParentsSelected,
    buildMenuPermissionSections,
    toggleTasksScope,
} from '../utils/wms-permission-menu';

// Renders permission checkboxes for both admin page and employee permissions page
export default function WmsPermissionCheckboxList({
    permissionOptions,
    selectedPermissions = [],
    onToggle,
    onChangePermissions,
    idPrefix = '',
    isEmployeePermissionsPage = false,
}) {
    const sections = buildMenuPermissionSections(permissionOptions);
    const selectedSet = new Set(selectedPermissions || []);

    const handleTitleClick = (tasks) => {
        if (!onChangePermissions) return;
        onChangePermissions(toggleTasksScope(selectedPermissions, tasks));
    };

    const renderTasks = (tasks, keyPrefix) =>
        (tasks || []).map((task) => {
            const parentOption = task.parentOption;
            const parentValue = parentOption.value;
            const parentChecked = selectedSet.has(parentValue);
            const parentLabel = task.name || getPermissionDisplayLabel(parentOption);

            return (
                <div key={`${keyPrefix}${parentValue}`} className='mb-1.5'>
                    <label className='inline-flex items-center text-sm font-normal'>
                        <input
                            type='checkbox'
                            className='w-4 h-4 text-blue-600 form-checkbox'
                            value={parentValue}
                            checked={parentChecked}
                            onChange={(event) => onToggle(parentValue, event.target.checked)}
                        />
                        <span className='ml-2'>{parentLabel}</span>
                    </label>

                    {(task.childOptions || []).map((childOption) => {
                        const childValue = childOption.value;
                        const childLabel = getPermissionDisplayLabel(childOption);
                        const childParent = getParentPermissionForValue(childValue);
                        const isParentSelected = childParent ? selectedSet.has(childParent) : true;

                        return (
                            <div key={`${keyPrefix}${childValue}`} className='mb-1 ml-6'>
                                <label className='inline-flex items-center text-sm font-normal'>
                                    <input
                                        type='checkbox'
                                        className='w-4 h-4 text-blue-600 form-checkbox'
                                        value={childValue}
                                        checked={selectedSet.has(childValue)}
                                        disabled={!isParentSelected}
                                        onChange={(event) => onToggle(childValue, event.target.checked)}
                                    />
                                    <span className='ml-2'>{childLabel}</span>
                                </label>
                            </div>
                        );
                    })}
                </div>
            );
        });

    // Employee: one column per category. Admin: 2-col grid of categories
    return (
        <div
            className={
                isEmployeePermissionsPage
                    ? 'grid w-full gap-x-12 gap-y-6'
                    : 'grid w-full grid-cols-1 gap-x-8 gap-y-3 sm:grid-cols-2'
            }
            style={
                isEmployeePermissionsPage
                    ? { gridTemplateColumns: `repeat(${Math.max(sections.length, 1)}, minmax(0, 1fr))` }
                    : undefined
            }
        >
            {sections.map((category) => {
                const categoryAllSelected = areAllParentsSelected(selectedPermissions, category.tasks);

                return (
                    <div key={`${idPrefix}${category.id}`} className='min-w-0'>
                        <button
                            type='button'
                            className='mb-3 text-lg font-bold text-left cursor-pointer hover:text-blue-800'
                            onClick={() => handleTitleClick(category.tasks)}
                            title={
                                categoryAllSelected
                                    ? `Unselect all ${category.name}`
                                    : `Select all ${category.name}`
                            }
                        >
                            {category.name}
                        </button>
                        <div className='ml-2'>{renderTasks(category.tasks, idPrefix)}</div>
                    </div>
                );
            })}
        </div>
    );
}
